'use strict';

/**
 * Keeps the header quick-link menu accessible independently from its visual dropdown state.
 */
(function initAccountQuickLinks() {
	var SELECTOR = '[data-account-quick-links="true"]';

	function syncMenuState($dropdown) {
		var open = $dropdown.hasClass('is-open');
		// KettyDo inserts its CTA asynchronously; include it in the existing keyboard navigation.
		$dropdown.find('[data-loyalty-component] a[href]').attr('role', 'menuitem');
		// Keep screen-reader state and keyboard reachability aligned with the visual state.
		$dropdown.find('.dd__menu').attr('aria-hidden', open ? 'false' : 'true');
		$dropdown.find('[role="menuitem"]').attr('tabindex', open ? '0' : '-1');
	}

	function closeMenu($dropdown) {
		$dropdown.removeClass('is-open');
		$dropdown.find('.dd__toggle').attr('aria-expanded', 'false');
		syncMenuState($dropdown);
	}

	function openMenu($dropdown) {
		$('.dd.is-open').not($dropdown).each(function closeOpenDropdown() {
			var $openDropdown = $(this);
			$openDropdown.removeClass('is-open');
			$openDropdown.find('.dd__toggle').attr('aria-expanded', 'false');
		});
		$dropdown.addClass('is-open');
		$dropdown.find('.dd__toggle').attr('aria-expanded', 'true');
		syncMenuState($dropdown);
	}

	function getFocusableElements($dropdown) {
		return $dropdown.find('.dd__toggle, [role="menuitem"]:not([tabindex="-1"])');
	}

	function observeDropdown($dropdown) {
		var element = $dropdown[0];
		if (!element || element._lvzAccountQuickLinksObserved) {
			return;
		}

		element._lvzAccountQuickLinksObserved = true;
		syncMenuState($dropdown);
		// The shared dropdown can change .is-open, so observe it instead of duplicating its logic.
		new MutationObserver(function onDropdownStateChange() {
			syncMenuState($dropdown);
		}).observe(element, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
	}

	$(function onReady() {
		$(SELECTOR).each(function initDropdown() {
			observeDropdown($(this));
		});
	});

	$(document).on('keydown', SELECTOR, function onQuickLinksKeydown(event) {
		var $dropdown = $(this);
		var $toggle = $dropdown.find('.dd__toggle');
		var $menuItems = $dropdown.find('[role="menuitem"]');
		var $focusable = getFocusableElements($dropdown);
		var activeIndex = $menuItems.index(document.activeElement);

		if (event.key === 'Escape' && $dropdown.hasClass('is-open')) {
			event.preventDefault();
			closeMenu($dropdown);
			$toggle.focus();
			return;
		}

		if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && document.activeElement === $toggle[0]) {
			event.preventDefault();
			openMenu($dropdown);
			$menuItems.eq(event.key === 'ArrowDown' ? 0 : $menuItems.length - 1).focus();
			return;
		}

		if (!$dropdown.hasClass('is-open')) {
			return;
		}

		if (event.key === 'Tab') {
			var first = $focusable.first()[0];
			var last = $focusable.last()[0];
			// Cycle focus between the toggle and menu items while the dropdown is open.
			if (event.shiftKey && document.activeElement === first) {
				event.preventDefault();
				last.focus();
			} else if (!event.shiftKey && document.activeElement === last) {
				event.preventDefault();
				first.focus();
			}
			return;
		}

		if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
			event.preventDefault();
			if (activeIndex === -1) {
				$menuItems.first().focus();
				return;
			}
			var nextIndex = activeIndex + (event.key === 'ArrowDown' ? 1 : -1);
			if (nextIndex < 0) {
				nextIndex = $menuItems.length - 1;
			} else if (nextIndex >= $menuItems.length) {
				nextIndex = 0;
			}
			$menuItems.eq(nextIndex).focus();
		}
	});

	$(document).on('click', SELECTOR + ' .dd__toggle', function onToggleClick() {
		var $dropdown = $(this).closest(SELECTOR);
		window.requestAnimationFrame(function syncAfterToggle() {
			syncMenuState($dropdown);
		});
	});

	$(document).on('click', SELECTOR + ' [role="menuitem"]', function onMenuItemClick() {
		closeMenu($(this).closest(SELECTOR));
	});
})();
